import React from 'react';
import { Button } from '../../../../common/Buttons';

/**
 * CopyReplaceConfirm Component
 * Final confirmation step with comment field
 */
const CopyReplaceConfirm = ({
  sourceDocument,
  targetDocument,
  comment,
  onCommentChange,
  onConfirm
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!comment.trim()) {
      alert('Please enter a comment before confirming the copy operation.');
      return;
    }
    onConfirm();
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ 
        marginBottom: '30px',
        padding: '20px',
        backgroundColor: '#fff3cd',
        borderRadius: '4px',
        border: '1px solid #ffeaa7'
      }}>
        <h4 style={{ margin: '0 0 10px 0', color: '#856404' }}>
          ⚠️ Confirm Copy & Replace Operation
        </h4>
        <p style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#856404' }}>
          You are about to replace all content in the target document with content from the source document.
        </p>
        <div style={{ fontSize: '14px', color: '#856404' }}>
          <strong>Source:</strong> {sourceDocument.partNumber} Rev {sourceDocument.revision}<br/>
          <strong>Target:</strong> {targetDocument.partNumber} Rev {targetDocument.revision}
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: '20px' }}>
          <label 
            htmlFor="comment"
            style={{ 
              display: 'block', 
              marginBottom: '8px',
              fontSize: '14px',
              fontWeight: '600',
              color: '#333'
            }}
          >
            Comment <span style={{ color: 'red' }}>*</span>
          </label>
          <textarea
            id="comment"
            value={comment}
            onChange={(e) => onCommentChange(e.target.value)}
            placeholder="Enter your comments about this copy operation..."
            required
            style={{
              width: '100%',
              minHeight: '100px',
              padding: '12px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '14px',
              fontFamily: 'inherit',
              resize: 'vertical'
            }}
          />
          <div style={{ 
            fontSize: '12px', 
            color: '#666', 
            marginTop: '4px' 
          }}>
            This comment will be recorded in the audit trail.
          </div>
        </div>

        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingTop: '20px',
          borderTop: '1px solid #dee2e6'
        }}>
          <div style={{ fontSize: '14px', color: '#666' }}>
            <strong>Editor:</strong> {localStorage.getItem('user_name') || 'Unknown User'}
          </div>
          
          <div style={{ display: 'flex', gap: '10px' }}>
            <Button
              type="button"
              variant="outline"
              size="md"
              onClick={() => window.history.back()}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="primary"
              size="md"
            >
              Confirm Copy & Replace
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CopyReplaceConfirm;
